import Header from "../../components/Header";
import Footer from "../../components/Footer";

import './styles.css';


function Contact() {
  return (
    <div className="">
        <Header 
        title={'Contact Us'}/>

        <section class="contact-us">
        <div class="row">
                <div class="contact-col">
                    <div>
                        <i class="fa fa-home"></i>
                        <span>
                            <h5>XYZ Road, ABC Building</h5>
                            <p>New York America</p>
                        </span>
                    </div>
                    <div>
                        <i class="fa fa-phone"></i>
                        <span>
                            <h5>+1 0123456789</h5>
                            <p>Monday to Saturday, 10AM to 6PM</p>
                        </span>
                    </div>
                    <div>
                        <i class="fa fa-envelope-o"></i>
                        <span>
                            <h5>info@gmail.com</h5>
                            <p>Email us your query</p>
                        </span>
                    </div>
                </div>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.03612512146!2d-74.30933714401378!3d40.6975399537724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2s!4v1687236250715!5m2!1sen!2s" width="600" height="450" style={{border:0,borderRadius:10}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>

        </section>

        <Footer/>
    </div>
  );
}

export default Contact;
